module.exports = __webpack_public_path__ + "components/country-flag/static/by-6810528d415a4abd3ed17fb1e7657769.svg";